import { select } from 'd3-selection';
import { scaleLinear } from 'd3-scale';
import { axisBottom } from 'd3-axis';

import { layoutGraph } from './layout-graph';
import { renderPanel } from './render-panel';
import { addTooltips } from './add-tooltips';
import { renderXAxis } from './render-x-axis';
import { TOOLTIP_MODE } from '../constants';

export function renderGraph(graph, containerElem) {

	const layout = layoutGraph(graph, containerElem);

	const container = select(containerElem);
	container.html('');

	if (graph.config.name) {
		container.node().classList.add(`hw_panel_graph_${graph.config.name}`);
	}

	const svg = container
		.append('svg')
		.attr('width', layout.width)
		.attr('height', layout.height);

	const defs = svg.append('defs');

	const panelsGroupElem = svg.append('g')
		.attr('class', 'hw_panel_graph_panels');

	const xExtent = graph.config.xAxis.config.range;

	const xScale = scaleLinear()
		.domain(xExtent)
		.range([
			layout.plotAreaX + layout.xPadding,
			layout.plotAreaX + layout.plotAreaWidth - layout.xPadding
		]);

	layout.panels.forEach((panelLayout, i) => {
		// Layout is null if the panel is not active
		if (panelLayout !== null) {
			renderPanel(panelsGroupElem, graph, graph.config.panels[i], i, panelLayout, layout.xPadding, xScale, defs);
		}
	});

	const xAxis = axisBottom()
		.scale(xScale)
		.tickSizeInner(5)
		.tickSizeOuter(0);

	if (graph.config.xAxis.config.tickValues !== null) {
		xAxis.tickValues(graph.config.xAxis.config.tickValues);
	}

	if (typeof graph.config.xAxis.config.formatter === 'function') {
		xAxis.tickFormat(graph.config.xAxis.config.formatter);
	}

	renderXAxis(svg, xAxis, layout.plotAreaY + layout.plotAreaHeight);

	if (graph.config.tooltipMode !== TOOLTIP_MODE.NONE) {
		addTooltips(graph.config.tooltipMode, graph, container, svg, layout, xScale);
	}

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-graph.js